module.exports = __webpack_public_path__ + "static/img/img10.2cfc8c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img10.jpg
// module id = fwaM
// module chunks = 1